export default __webpack_public_path__ + "static/media/aerobic.f0a4bc3e.jpg";